import React, { FC } from 'react';

import Rive, { Fit, Layout } from '@rive-app/react-canvas';

import { Loader as DesignSystemLoader } from '~/design-system/components/Loader/Loader';
import { useIsHomePageRedesignEnabled } from '~/modules/home/useIsHomePageRedesignEnabled';

import styles from './styles.module.scss';

type FullscreenPreloaderViewProps = {
  useDesignSystemLoader?: boolean;
};

const FullscreenPreloaderView: FC<FullscreenPreloaderViewProps> = ({
  useDesignSystemLoader = false,
}) => {
  return (
    <div className={styles.container}>
      {useDesignSystemLoader ? (
        <DesignSystemLoader label="Loading" />
      ) : (
        <div className={styles.animation}>
          <Rive
            layout={
              new Layout({
                fit: Fit.Cover,
              })
            }
            shouldResizeCanvasToContainer
            src="/animations/loader.riv"
          />
        </div>
      )}
    </div>
  );
};

const FullscreenPreloader: FC = () => <FullscreenPreloaderView />;

export const HomePageRedesignFullscreenPreloader: FC = () => {
  const isHomePageRedesignEnabled = useIsHomePageRedesignEnabled();

  return (
    <FullscreenPreloaderView
      useDesignSystemLoader={isHomePageRedesignEnabled}
    />
  );
};

export default FullscreenPreloader;
